<template>
  <div class="ticketaction-list">
    <Toolbar />
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-ticket</v-icon>{{$t('ticket.ticketactions')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <TicketactionFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
            @click:row="showHandlerSubTicketAction"
            @contextmenu:row="showHandlerExt"
          >
          <template slot="item.date" slot-scope="{ item }">
            {{ formatDateTime(item['date'], 'long') }}
          </template>
          <template slot="item.type" slot-scope="{ item }">
            <v-chip  class="ma-1 font-weight-bold"  label  color="secondary" v-if="language == 'fr'">
              <v-icon left v-if="item['type'].public">mdi-eye</v-icon>
              <v-icon left v-else>mdi-eye-off</v-icon>
              {{ item['type'].namefr }}
            </v-chip>
            <v-chip  class="ma-1 font-weight-bold"  label  color="secondary" v-else>
              <v-icon left v-if="item['type'].public">mdi-eye</v-icon>
              <v-icon left v-else>mdi-eye-off</v-icon>
              {{ item['type'].name }}
            </v-chip>
          </template>
          <template slot="item.content" slot-scope="{ item }">
            <span  class="tablehtmleditor" v-html="item['content']"></span>         
          </template>


          
            <ActionCell
              slot="item.action"
              slot-scope="props"

              :handle-show="() => showHandlerSub(props.item.ticket,'Ticketaction',props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import i18n from '../../i18n.js';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import TicketactionFilterForm from '../../components/ticketaction/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'TicketactionList',
  servicePrefix: 'Ticketaction',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    TicketactionFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.date'), value: 'date' },
        { text: this.$t('global.createdby'), value: 'ticket.createdBy.login' },
        { text: this.$t('ticket.number'), value: 'ticket.id'},
        { text: this.$t('contact.customer'), value: 'ticket.customer.name'},
        { text: this.$t('ticket.actiontype'), value: 'type' },
        { text: this.$t('ticket.ticket'), value: 'ticket.name' },
        { text: this.$t('ticket.assigned'), value: 'ticket.assigned.login' },
        { text: this.$t('ticket.content'), value: 'content' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        },
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['date'], sortDesc : [true]},
      optionsTicket: {sortBy : ['status.finish','created'], sortDesc : [false,true]}
    };
  },
  computed: {
    ...mapGetters('ticketaction', {
      items: 'list'
    }),
    ...mapFields('ticketaction', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    language() {
      return i18n.locale;
    }
  },
  methods: {
    ...mapActions('ticketaction', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    showHandlerSubTicketAction(item){
      this.showHandlerSub(item.ticket,'Ticketaction',item);
    },
    showHandlerExt(event, item) {
      let routeData = this.$router.resolve({
        name: `TicketShow`,
        params: {id: '/api/tickets/' + item.item['ticket'].id}
      });
      window.open(routeData.href, '_blank');
      event.preventDefault()
    },
  }
};
</script>
